import { LTL_THRESHOLDS } from '../types';

/** Minimal shape for volume-threshold checks (matches shipment-level metrics output). */
export interface LTLMetricsForThresholds {
  linearFeet: number;
  totalCubicFeet: number;
  totalWeight: number;
  pcf: number;
}

interface LTLThresholdWarnings {
  exceedsLinearFeet: boolean;
  exceedsCubicFeet: boolean;
  exceedsWeight: boolean;
  hasAnyWarning: boolean;
}

export function checkLTLThresholds(
  metrics: LTLMetricsForThresholds
): LTLThresholdWarnings {
  const exceedsLinearFeet = metrics.linearFeet > LTL_THRESHOLDS.MAX_LINEAR_FEET;
  const exceedsCubicFeet =
    metrics.totalCubicFeet > LTL_THRESHOLDS.MAX_CUBIC_FEET;
  const exceedsWeight = metrics.totalWeight > LTL_THRESHOLDS.MAX_WEIGHT_LBS;

  return {
    exceedsLinearFeet,
    exceedsCubicFeet,
    exceedsWeight,
    hasAnyWarning: exceedsLinearFeet || exceedsCubicFeet || exceedsWeight,
  };
}
